import { ArrayType } from '@angular/compiler'
import { Component, OnInit, OnChanges, Input, SimpleChanges, Output, EventEmitter } from '@angular/core'
import { FormGroup, FormBuilder, FormControl } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
// import {UtilsService} from '../../../../service/utils/utils.service';

/**
 * <app-base-search
 *  [searchConfig]="searchConfig"
 *  [pageIndex]="params.page"
 *  [pageSize]="params.size"
 *  (searchParams)="onSearchParams($event)">
 * </app-base-search>
 *
 * searchConfig = [
 *  { type: 'input', name: 'contractNumber', nick: '输入框', placeholder: '请输入xxx', disabled: false },
 *
 *  { type: 'timePiker', name: 'timeData', nick: '日期选择', dateFormat: 'yyyy/MM/dd', startAt: 'createAtStart', endAt: 'createAtEnd', disabled: false },
 *
 *  { type: 'select', name: 'status', nick: '下拉选择框', placeholder: '请选择xxx', data: parameter, disabled: false },
 *
 *  { type: 'cascader', name: 'cascader', nick: '级联选择', placeholder: '请选择xxx', data: parameter, disabled: false },
 *
 *  { type: 'treeSelect', name: 'cascader', nick: '级联选择', placeholder: '请选择xxx', data: parameter, disabled: false },
 *
 *  { type: 'hidden', name: 'status', nick: '下拉选择框', placeholder: '请选择xxx', value: '2', disabled: false},
 * ]
 *
 * 使用 cascader 搜索，要在树形数据生成完成后，才能加载搜素栏组件！具体可以参考内容列表页。
 */

@Component({
  selector: 'app-base-search',
  templateUrl: './base-search.component.html',
  styleUrls: ['./base-search.component.scss'],
})
export class BaseSearchComponent implements OnInit, OnChanges {
  constructor(private activeRouter: ActivatedRoute, private fb: FormBuilder, private router: Router) // private utilService: UtilsService,
  {}

  /**
   * 配置文件必传
   */
  @Input() searchConfig: any
  /**
   * 参数-页数 必传
   */
  @Input() pageIndex: any = 1
  /**
   * 参数-每页条数 必传
   */
  @Input() pageSize: any = 10
  /**
   * 参数-搜索参数保存方法 非必传
   * true 搜索参数保存到url上，在页面监听路由变化。
   * false 直接交由页面处理， 配合 searchParams 使用
   */
  @Input() routeJump = true
  /**
   * 发布搜索参数改变的回调
   */
  @Output() searchParams = new EventEmitter<any>()

  public validateForm: FormGroup // 表单
  public timePikerKeys: Array<any> = [] // 时间搜索 keys
  public cascaderKeys: Array<any> = [] // 分类搜索 keys
  public disableFormControl = [] // 禁用的表单，在重置是不会被清空。

  public pathname = window.location.pathname
  public pageParams: any = {}

  ngOnInit(): void {
    // 生成动态表单
    this.dynamicForm()
    // 获取路由参数并赋值搜索
    this.activeRouter.queryParams.subscribe((data) => {
      this.getParams(data)
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pathname = window.location.pathname
    if ((this.validateForm && changes['pageIndex'] && changes['pageIndex'].currentValue && changes['pageIndex'].previousValue) || (changes['pageSize'] && changes['pageSize'].currentValue && changes['pageSize'].previousValue)) {
      this.pageParams.page = this.pageIndex
      this.pageParams.size = this.pageSize
      this.saveParams()
    }
  }

  disableForm() {
    if (Array.isArray(this.searchConfig)) {
      this.searchConfig.forEach((item) => {
        if (item.disabled) {
          this.validateForm.get(item.name).disable()
          this.disableFormControl.push(item)
        } else {
          this.validateForm.get(item.name).enable()
        }
      })
    }
  }

  /**
   * 回显数据
   *
   * @private
   * @param {*} res
   * @memberof BannerListComponent
   */
  private getParams(res): void {
    const routeParams = res
    const formData = this.validateForm.value

    // 遍历路由参数
    Object.keys(formData).forEach((i) => {
      if (routeParams[i] && !Array.isArray(routeParams[i])) {
        this.validateForm.get(i).setValue(routeParams[i].toString())
      }
    })
    // 给时间选择器赋值
    this.timePikerKeys.forEach((i) => {
      if (routeParams[i.startAt] && routeParams[i.endAt]) {
        this.validateForm.get(i.name).setValue([new Date(+routeParams[i.startAt]), new Date(+routeParams[i.endAt] - 1)])
      }
    })
    // 给联级选择器赋值
    this.cascaderKeys.forEach((i) => {
      if (routeParams[i.name]) {
        const cascaderValue = this.getClassificationPathElderIdByClassificationId(routeParams[i.name], i.classifyList, [])
        this.validateForm.get(i.name).setValue(cascaderValue)
      }
    })
    // 发布消息
    // let tempParams = Object.assign(this.pageParams, this.validateForm.value);
    // tempParams = this.delTimeKeyAndValue(tempParams);
    // this.searchParams.emit(tempParams);
  }

  /**
   * 生成动态表单
   *
   * @memberof BannerListComponent
   */
  public dynamicForm(): void {
    // 响应式表单
    this.validateForm = this.fb.group({})

    if (Array.isArray(this.searchConfig)) {
      this.searchConfig.forEach((item) => {
        this.validateForm.addControl(item.name, new FormControl({ value: null, disabled: item.disabled }))

        if (item.type === 'timePiker') {
          this.timePikerKeys.push(item)
        }
        if (item.type === 'cascader') {
          this.cascaderKeys.push(item)
        }
        if (item.type === 'hidden') {
          this.validateForm.addControl(item.name, new FormControl(item.value))
        }
      })
    }

    // 参数
    this.pageParams.page = this.pageIndex
    this.pageParams.size = this.pageSize
  }

  /**
   * 搜索
   *
   * @memberof BannerListComponent
   */
  public search(): void {
    this.pageParams.page = 1
    this.saveParams()
  }
  public enterSubmit(event): void {
    if (event.keyCode === 13) {
      event.preventDefault()
      this.search()
    }
    return
  }
  /**
   * 搜索时保存数据
   *
   * @memberof BannerListComponent
   */
  private saveParams(): void {
    const params = this.delTimeKeyAndValue(this.disposeParams())
    if (this.routeJump) {
      this.router.navigate([this.pathname], { queryParams: params })
    } else {
      this.searchParams.emit(params)
    }
  }

  /**
   * 重置
   *
   * @memberof BannerListComponent
   */
  public reset(): void {
    this.pageParams.page = this.pageIndex
    this.pageParams.size = this.pageSize
    this.searchConfig.forEach((item) => {
      this.validateForm.get(item.name).reset()
    })
    const params = this.delTimeKeyAndValue(this.disposeParams())
    if (this.routeJump) {
      this.router.navigate([this.pathname], { queryParams: params })
    } else {
      this.searchParams.emit(this.pageParams)
    }
  }

  delTimeKeyAndValue(params): any {
    const resParams = JSON.parse(JSON.stringify(params))
    for (const key in resParams) {
      if (!resParams[key]) {
        Reflect.deleteProperty(resParams, key)
      }
    }
    this.timePikerKeys.forEach((item) => {
      if (resParams[item.name]) {
        Reflect.deleteProperty(resParams, item.name)
      }
    })
    return resParams
  }

  // 搜索的时候处理时间选择器的时间
  disposeParams() {
    const params = Object.assign(JSON.parse(JSON.stringify(this.pageParams)), this.validateForm.value)
    // 时间选择器
    this.timePikerKeys.forEach((i) => {
      if (Array.isArray(params[i.name])) {
        this.getTime(params[i.name], i, params)
      }
    })
    // 分类选择器
    this.cascaderKeys.forEach((i) => {
      if (params[i.name]) {
        const value = params[i.name]
        params[i.name] = Array.isArray(value) && value.length ? value[value.length - 1] : ''
      }
    })
    return JSON.parse(JSON.stringify(params))
  }

  /**
   * 时间选择器 获取时间
   *
   * @param {*} dateRange
   * @param {*} item
   * @param {*} params
   * @memberof UtilService
   */
  public getTime(dateRange, item, params): void {
    if (dateRange && dateRange.length === 2) {
      params[item.startAt] = this.formatDate(dateRange[0])
      params[item.endAt] = this.formatDate(dateRange[1]) + 86400000
    }
  }

  /**
   * 时间选择器 转换时间
   *
   * @param {*} datetime
   * @returns
   * @memberof UtilService
   */
  public formatDate(datetime: Date): number {
    // 获取年月日 slice(-2)过滤掉大于10日期前面的0
    const year = datetime.getFullYear()
    const month = ('0' + (datetime.getMonth() + 1)).slice(-2)
    const date = ('0' + datetime.getDate()).slice(-2)
    // 拼接
    const result = year + '/' + month + '/' + date

    const data = new Date(result).getTime()
    // 返回
    return data
  }

  getClassificationPathElderIdByClassificationId(id, arr, ids) {
    const _ids = ids
    let parent: number
    arr.forEach((i) => {
      if (i.id === +id) {
        parent = i.pid
        _ids.unshift(+id)
      }
    })
    if (parent === -1 || !id) {
      return _ids
    } else {
      return this.getClassificationPathElderIdByClassificationId(parent, arr, _ids)
    }
  }
}
